import { render, staticRenderFns } from "./PrivacyIndex.vue?vue&type=template&id=7ec6a741&scoped=true&"
import script from "./PrivacyIndex.vue?vue&type=script&lang=js&"
export * from "./PrivacyIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec6a741",
  null
  
)

export default component.exports